import React, { Component } from 'react'
import { withFormik } from 'formik'
import Translation from '../../Translation/cont/Translation'
import getTranslationStringById from '../../Translation/func/getTranslationStringById'
import PresetSectionNav from './PresetSectionNav'
import PresetPreview from './PresetPreview'
import PositionGrid from './PositionGrid'
import ColorInputWithTransparent from './ColorInputWithTransparent'
import ImageUpload from '../../forms/fields/ImagesGeneral/ImageUpload'
import ButtonSubmitCancel from '../../general/ButtonSubmitCancel'
import { EDIT_SOCIAL_MEDIA_CAP } from '../../../constants/caps'
import WrapperPageWithSecondNav from '../../WrapperPage/present/WrapperPageWithSecondNav'
import SOCIAL_MEDIA_FORMATS from '../../../constants/socialMediaFormats'

const DEFAULT_SETTINGS = {
    general:    { name: '', posterMaxWidth: 50, posterX: 50, posterY: 50 },
    background: { color: '#1a1a2e', imageUrl: null },
    border: {
        corners:      'eckig',
        borderRadius: 0,
        bevelSize:    20,
        bevelCorners: { ol: true, or: true, ul: false, ur: false },
        style:        'solid',
        width:        0,
        color:        '#ffffff',
    },
    gradient:  { enabled: false, type: 'linear', angle: 180, stops: [
        { color: '#181020', position: 0 },
        { color: '#060810', position: 100 },
    ] },
    title:     { color: '#ffffff', backgroundColor: 'transparent', font: 'inherit', size: 72, align: 'center', position: 'bottom-center' },
    freetext:  { color: '#ffffff', backgroundColor: 'transparent', font: 'inherit', size: 48, align: 'center', position: 'bottom-center' },
    datetime:  { color: '#C8C0B0', backgroundColor: 'transparent', font: 'inherit', size: 36, align: 'center', position: 'bottom-center' },
    badge:   { enabled: true, shape: 'circle', width: 200, height: 200, x: 80, y: 60, backgroundColor: '#ef7d00', color: '#ffffff', defaultText: 'NEU', borderRadius: 0 },
    fsk:       { enabled: false, position: 'bottom-left', size: 100 },
    logo:      { imageUrl: null, position: 'bottom-right', size: 150 },
    cta:       { color: '#ffffff', backgroundColor: '#ef7d00', font: 'inherit', size: 32, align: 'center', position: 'bottom-center' },
    followup:  { presetId: null },
}

function buildInitialValues(preset) {
    const stored = preset ? (preset.settings || {}) : {}
    const settings = Object.keys(DEFAULT_SETTINGS).reduce((acc, key) => {
        const section = Object.assign({}, DEFAULT_SETTINGS[key], stored[key] || {})
        if (key === 'gradient' && (!section.stops || !section.stops.length)) {
            section.stops = DEFAULT_SETTINGS.gradient.stops
        }
        acc[key] = section
        return acc
    }, {})
    return {
        name:     preset ? (preset.name || '') : '',
        settings,
    }
}

class PageSocialMediaPreset extends Component {
    constructor(props) {
        super(props)
        this.state = {
            activeSection:      'general',
            showDiscardConfirm: false,
            previewFormatId:    SOCIAL_MEDIA_FORMATS[0].id,
        }
    }

    handleSectionChange(sectionId) {
        this.setState({ activeSection: sectionId })
    }

    handleBack() {
        if (this.props.dirty) {
            this.setState({ showDiscardConfirm: true })
            return
        }
        this.props.onBack()
    }

    confirmDiscard() {
        this.setState({ showDiscardConfirm: false })
        this.props.onBack()
    }

    renderSection() {
        const { activeSection } = this.state
        const { values, setFieldValue, presets, presetId } = this.props
        const { settings, name } = values

        switch (activeSection) {
            case 'general':
                return (
                    <div className="preset-settings-panel">
                        <div className="preset-settings-panel__field">
                            <label className="field-label text-small-bold"><Translation id="social_media_preset_name" /></label>
                            <input
                                type="text"
                                className="input-text-box"
                                value={name}
                                onChange={e => setFieldValue('name', e.target.value)}
                            />
                        </div>
                        <div className="preset-settings-panel__field">
                            <label className="field-label text-small-bold"><Translation id="social_media_poster_max_width" /></label>
                            <input
                                type="number"
                                className="input-text-box input-text-box--short"
                                value={settings.general.posterMaxWidth}
                                min={10}
                                max={100}
                                onChange={e => setFieldValue('settings.general.posterMaxWidth', parseInt(e.target.value, 10))}
                            />
                        </div>
                        <div className="preset-settings-panel__field">
                            <label className="field-label text-small-bold"><Translation id="social_media_x_percent" /></label>
                            <input
                                type="number"
                                className="input-text-box input-text-box--short"
                                value={settings.general.posterX}
                                min={0}
                                max={100}
                                onChange={e => setFieldValue('settings.general.posterX', parseInt(e.target.value, 10))}
                            />
                        </div>
                        <div className="preset-settings-panel__field">
                            <label className="field-label text-small-bold"><Translation id="social_media_y_percent" /></label>
                            <input
                                type="number"
                                className="input-text-box input-text-box--short"
                                value={settings.general.posterY}
                                min={0}
                                max={100}
                                onChange={e => setFieldValue('settings.general.posterY', parseInt(e.target.value, 10))}
                            />
                        </div>
                    </div>
                )

            case 'background':
                return (
                    <div className="preset-settings-panel">
                        <div className="preset-settings-panel__field">
                            <label className="field-label text-small-bold"><Translation id="social_media_background_color" /></label>
                            <ColorInputWithTransparent
                                value={settings.background.color || '#1a1a2e'}
                                onChange={v => setFieldValue('settings.background.color', v)}
                            />
                        </div>
                        <div className="preset-settings-panel__field">
                            <label className="field-label text-small-bold"><Translation id="advertisement_background_image" /></label>
                            {settings.background.imageUrl ? (
                                <div className="preset-bg-image-preview">
                                    <img src={settings.background.imageUrl} className="preset-bg-image-preview__thumb" alt="" />
                                    <button type="button" className="button button--small"
                                        onClick={() => setFieldValue('settings.background.imageUrl', null)}>
                                        <Translation id="remove_button" />
                                    </button>
                                </div>
                            ) : (
                                <ImageUpload
                                    autoUpload={true}
                                    hideAdditionalText={true}
                                    onUploadStart={() => {}}
                                    onUploadEndSuccess={data => setFieldValue('settings.background.imageUrl', data.source_url)}
                                    onUploadEndError={() => {}}
                                />
                            )}
                        </div>
                    </div>
                )

            case 'border':
                return (
                    <div className="preset-settings-panel">
                        <div className="preset-settings-panel__field">
                            <label className="field-label text-small-bold"><Translation id="social_media_corners" /></label>
                            <div className="radio-group">
                                {[['eckig', 'social_media_corner_square'], ['rund', 'social_media_corner_round'], ['abgeschrägt', 'social_media_corner_beveled']].map(([val, transId]) => (
                                    <label key={val} className="radio-label text-small-bold">
                                        <input
                                            type="radio"
                                            name="corners"
                                            value={val}
                                            checked={settings.border.corners === val}
                                            onChange={() => setFieldValue('settings.border.corners', val)}
                                        />
                                        <Translation id={transId} />
                                    </label>
                                ))}
                            </div>
                        </div>
                        {settings.border.corners === 'rund' && (
                            <div className="preset-settings-panel__field">
                                <label className="field-label text-small-bold"><Translation id="social_media_border_radius_px" /></label>
                                <input
                                    type="number"
                                    className="input-text-box input-text-box--short"
                                    value={settings.border.borderRadius}
                                    onChange={e => setFieldValue('settings.border.borderRadius', parseInt(e.target.value, 10))}
                                />
                            </div>
                        )}
                        {settings.border.corners === 'abgeschrägt' && (
                            <>
                                <div className="preset-settings-panel__field">
                                    <label className="field-label text-small-bold"><Translation id="social_media_corners" /></label>
                                    <div className="checkbox-group">
                                        {[['ol', 'social_media_corner_ol'], ['or', 'social_media_corner_or'], ['ul', 'social_media_corner_ul'], ['ur', 'social_media_corner_ur']].map(([key, transId]) => (
                                            <label key={key} className="checkbox-label text-small-bold">
                                                <input
                                                    type="checkbox"
                                                    checked={!!(settings.border.bevelCorners && settings.border.bevelCorners[key])}
                                                    onChange={e => setFieldValue('settings.border.bevelCorners', Object.assign({}, settings.border.bevelCorners, { [key]: e.target.checked }))}
                                                />
                                                <Translation id={transId} />
                                            </label>
                                        ))}
                                    </div>
                                </div>
                                <div className="preset-settings-panel__field">
                                    <label className="field-label text-small-bold"><Translation id="social_media_bevel_size_px" /></label>
                                    <input
                                        type="number"
                                        className="input-text-box input-text-box--short"
                                        value={settings.border.bevelSize}
                                        onChange={e => setFieldValue('settings.border.bevelSize', parseInt(e.target.value, 10))}
                                    />
                                </div>
                            </>
                        )}
                        <div className="preset-settings-panel__field">
                            <label className="field-label text-small-bold"><Translation id="social_media_border_width_px" /></label>
                            <input
                                type="number"
                                className="input-text-box input-text-box--short"
                                value={settings.border.width}
                                onChange={e => setFieldValue('settings.border.width', parseInt(e.target.value, 10))}
                            />
                        </div>
                        <div className="preset-settings-panel__field">
                            <label className="field-label text-small-bold"><Translation id="social_media_color" /></label>
                            <ColorInputWithTransparent
                                value={settings.border.color}
                                onChange={v => setFieldValue('settings.border.color', v)}
                            />
                        </div>
                    </div>
                )

            case 'gradient':
                return (
                    <div className="preset-settings-panel">
                        <div className="preset-settings-panel__field">
                            <label className="field-label text-small-bold"><Translation id="social_media_gradient_overlay" /></label>
                            <input type="checkbox" className="tgl tgl-flat" id="gradient-enabled"
                                checked={settings.gradient.enabled}
                                onChange={e => setFieldValue('settings.gradient.enabled', e.target.checked)} />
                            <label className="tgl-btn" htmlFor="gradient-enabled"></label>
                        </div>
                        {settings.gradient.enabled && (
                            <>
                                <div className="preset-settings-panel__field">
                                    <label className="field-label text-small-bold"><Translation id="social_media_gradient_type" /></label>
                                    <div className="radio-group">
                                        {[['linear', 'Linear'], ['radial', 'Radial'], ['conic', 'Conic']].map(([val, label]) => (
                                            <label key={val} className="radio-label text-small-bold">
                                                <input type="radio" name="gradient-type" value={val}
                                                    checked={settings.gradient.type === val}
                                                    onChange={() => setFieldValue('settings.gradient.type', val)} />
                                                {label}
                                            </label>
                                        ))}
                                    </div>
                                </div>
                                {settings.gradient.type === 'linear' && (
                                    <div className="preset-settings-panel__field">
                                        <label className="field-label text-small-bold"><Translation id="social_media_gradient_angle" /></label>
                                        <input type="number" className="input-text-box input-text-box--short"
                                            value={settings.gradient.angle}
                                            min={0} max={360}
                                            onChange={e => setFieldValue('settings.gradient.angle', parseInt(e.target.value, 10))} />
                                    </div>
                                )}
                                <div className="preset-settings-panel__field">
                                    <label className="field-label text-small-bold"><Translation id="social_media_gradient_stops" /></label>
                                    <div className="gradient-stop-list">
                                        {settings.gradient.stops.map((stop, i) => (
                                            <div key={i} className="gradient-stop">
                                                <ColorInputWithTransparent
                                                    value={stop.color}
                                                    onChange={v => {
                                                        const stops = settings.gradient.stops.map((s, idx) =>
                                                            idx === i ? Object.assign({}, s, { color: v }) : s
                                                        )
                                                        setFieldValue('settings.gradient.stops', stops)
                                                    }} />
                                                <input type="number" className="gradient-stop__position"
                                                    value={stop.position}
                                                    min={0} max={100}
                                                    onChange={e => {
                                                        const stops = settings.gradient.stops.map((s, idx) =>
                                                            idx === i ? Object.assign({}, s, { position: parseInt(e.target.value, 10) }) : s
                                                        )
                                                        setFieldValue('settings.gradient.stops', stops)
                                                    }} />
                                                {settings.gradient.stops.length > 2 && (
                                                    <button type="button" className="gradient-stop__remove"
                                                        onClick={() => setFieldValue('settings.gradient.stops',
                                                            settings.gradient.stops.filter((_, idx) => idx !== i)
                                                        )}>×</button>
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                    <button type="button" className="gradient-stop-add text-small-bold"
                                        onClick={() => setFieldValue('settings.gradient.stops',
                                            settings.gradient.stops.concat({ color: '#000000', position: 50 })
                                        )}>
                                        <Translation id="social_media_gradient_add_stop" />
                                    </button>
                                </div>
                            </>
                        )}
                    </div>
                )

            case 'title':
            case 'freetext':
            case 'datetime':
            case 'cta':
                return this.renderTextSection(activeSection)

            case 'badge':
                return (
                    <div className="preset-settings-panel">
                        <div className="preset-settings-panel__field">
                            <label className="field-label text-small-bold"><Translation id="social_media_active_by_default" /></label>
                            <input type="checkbox" className="tgl tgl-flat" id="badge-enabled"
                                checked={settings.badge.enabled}
                                onChange={e => setFieldValue('settings.badge.enabled', e.target.checked)} />
                            <label className="tgl-btn" htmlFor="badge-enabled"></label>
                        </div>
                        <div className="preset-settings-panel__field">
                            <label className="field-label text-small-bold"><Translation id="social_media_badge_shape" /></label>
                            <div className="radio-group">
                                {[['square', 'social_media_shape_square'], ['rounded', 'social_media_shape_rounded'], ['circle', 'social_media_shape_circle']].map(([val, transId]) => (
                                    <label key={val} className="radio-label text-small-bold">
                                        <input type="radio" name="badge-shape" value={val}
                                            checked={settings.badge.shape === val}
                                            onChange={() => setFieldValue('settings.badge.shape', val)} />
                                        <Translation id={transId} />
                                    </label>
                                ))}
                            </div>
                        </div>
                        {settings.badge.shape === 'rounded' && (
                            <div className="preset-settings-panel__field">
                                <label className="field-label text-small-bold"><Translation id="social_media_border_radius_px" /></label>
                                <input type="number" className="input-text-box input-text-box--short"
                                    value={settings.badge.borderRadius}
                                    onChange={e => setFieldValue('settings.badge.borderRadius', parseInt(e.target.value, 10))} />
                            </div>
                        )}
                        <div className="preset-settings-panel__field">
                            <label className="field-label text-small-bold"><Translation id="social_media_width_px" /></label>
                            <input type="number" className="input-text-box input-text-box--short"
                                value={settings.badge.width}
                                onChange={e => setFieldValue('settings.badge.width', parseInt(e.target.value, 10))} />
                        </div>
                        <div className="preset-settings-panel__field">
                            <label className="field-label text-small-bold"><Translation id="social_media_height_px" /></label>
                            <input type="number" className="input-text-box input-text-box--short"
                                value={settings.badge.height}
                                onChange={e => setFieldValue('settings.badge.height', parseInt(e.target.value, 10))} />
                        </div>
                        <div className="preset-settings-panel__field">
                            <label className="field-label text-small-bold"><Translation id="social_media_x_percent" /></label>
                            <input type="number" className="input-text-box input-text-box--short"
                                value={settings.badge.x}
                                min={0} max={100}
                                onChange={e => setFieldValue('settings.badge.x', parseInt(e.target.value, 10))} />
                        </div>
                        <div className="preset-settings-panel__field">
                            <label className="field-label text-small-bold"><Translation id="social_media_y_percent" /></label>
                            <input type="number" className="input-text-box input-text-box--short"
                                value={settings.badge.y}
                                min={0} max={100}
                                onChange={e => setFieldValue('settings.badge.y', parseInt(e.target.value, 10))} />
                        </div>
                        <div className="preset-settings-panel__field">
                            <label className="field-label text-small-bold"><Translation id="social_media_default_text" /></label>
                            <input type="text" className="input-text-box"
                                value={settings.badge.defaultText}
                                onChange={e => setFieldValue('settings.badge.defaultText', e.target.value)} />
                        </div>
                        <div className="preset-settings-panel__field">
                            <label className="field-label text-small-bold"><Translation id="social_media_background_color" /></label>
                            <ColorInputWithTransparent
                                value={settings.badge.backgroundColor}
                                onChange={v => setFieldValue('settings.badge.backgroundColor', v)} />
                        </div>
                        <div className="preset-settings-panel__field">
                            <label className="field-label text-small-bold"><Translation id="print_flyer_text_color" /></label>
                            <ColorInputWithTransparent
                                value={settings.badge.color}
                                onChange={v => setFieldValue('settings.badge.color', v)} />
                        </div>
                    </div>
                )

            case 'fsk':
                return (
                    <div className="preset-settings-panel">
                        <div className="preset-settings-panel__field">
                            <label className="field-label text-small-bold"><Translation id="advertisement_active" /></label>
                            <input type="checkbox" className="tgl tgl-flat" id="fsk-enabled"
                                checked={settings.fsk.enabled}
                                onChange={e => setFieldValue('settings.fsk.enabled', e.target.checked)} />
                            <label className="tgl-btn" htmlFor="fsk-enabled"></label>
                        </div>
                        <div className="preset-settings-panel__field">
                            <label className="field-label text-small-bold"><Translation id="social_media_size_px" /></label>
                            <input type="number" className="input-text-box input-text-box--short"
                                value={settings.fsk.size}
                                onChange={e => setFieldValue('settings.fsk.size', parseInt(e.target.value, 10))} />
                        </div>
                        <PositionGrid
                            value={settings.fsk.position}
                            onChange={v => setFieldValue('settings.fsk.position', v)}
                        />
                    </div>
                )

            case 'logo':
                return (
                    <div className="preset-settings-panel">
                        <div className="preset-settings-panel__field">
                            <label className="field-label text-small-bold"><Translation id="social_media_upload_logo" /></label>
                            {settings.logo.imageUrl ? (
                                <div className="preset-bg-image-preview">
                                    <img src={settings.logo.imageUrl} className="preset-bg-image-preview__thumb" alt="" />
                                    <button type="button" className="button button--small"
                                        onClick={() => setFieldValue('settings.logo.imageUrl', null)}>
                                        <Translation id="remove_button" />
                                    </button>
                                </div>
                            ) : (
                                <ImageUpload
                                    autoUpload={true}
                                    hideAdditionalText={true}
                                    onUploadStart={() => {}}
                                    onUploadEndSuccess={data => setFieldValue('settings.logo.imageUrl', data.source_url)}
                                    onUploadEndError={() => {}}
                                />
                            )}
                        </div>
                        <div className="preset-settings-panel__field">
                            <label className="field-label text-small-bold"><Translation id="social_media_size_px" /></label>
                            <input type="number" className="input-text-box input-text-box--short"
                                value={settings.logo.size}
                                onChange={e => setFieldValue('settings.logo.size', parseInt(e.target.value, 10))} />
                        </div>
                        <PositionGrid
                            value={settings.logo.position}
                            onChange={v => setFieldValue('settings.logo.position', v)}
                        />
                    </div>
                )

            case 'followup': {
                const { translationStrings, currentLang, translationDebug } = this.props
                const noneLabel = getTranslationStringById('option_none', translationStrings, currentLang, '—', translationDebug)
                const otherPresets = presets
                    ? presets.filter(p => p.id !== presetId)
                    : []
                return (
                    <div className="preset-settings-panel">
                        <div className="preset-settings-panel__field">
                            <label className="field-label text-small-bold"><Translation id="social_media_followup_preset" /></label>
                            {otherPresets.length === 0 ? (
                                <p className="text-small-regular"><Translation id="social_media_no_further_presets" /></p>
                            ) : (
                                <select className="select-box"
                                    value={typeof settings.followup.presetId === 'string' ? settings.followup.presetId : ''}
                                    onChange={e => setFieldValue('settings.followup.presetId', e.target.value || null)}>
                                    <option value="">{noneLabel}</option>
                                    {otherPresets.map(p => (
                                        <option key={p.id} value={p.id}>{p.name || p.id}</option>
                                    ))}
                                </select>
                            )}
                        </div>
                    </div>
                )
            }

            default:
                return <div className="preset-settings-panel"><p><Translation id="social_media_section_not_found" /></p></div>
        }
    }

    renderTextSection(section) {
        const { values, setFieldValue } = this.props
        const settings = values.settings[section]
        const isDatetime = section === 'datetime'
        // Title/Freetext/Datetime render as one stacked block anchored at a single
        // shared position — the grid shown on any of the three edits the same value.
        const isGroupedText = section === 'title' || section === 'freetext' || section === 'datetime'
        const positionValue = isGroupedText ? values.settings.title.position : settings.position
        const positionField = isGroupedText ? 'settings.title.position' : `settings.${section}.position`
        return (
            <div className="preset-settings-panel">
                <div className="preset-settings-panel__field">
                    <label className="field-label text-small-bold"><Translation id="print_flyer_text_color" /></label>
                    <ColorInputWithTransparent
                        value={settings.color}
                        onChange={v => setFieldValue(`settings.${section}.color`, v)} />
                </div>
                {!isDatetime && (
                    <div className="preset-settings-panel__field">
                        <label className="field-label text-small-bold"><Translation id="social_media_background_color" /></label>
                        <ColorInputWithTransparent
                            value={settings.backgroundColor || 'transparent'}
                            onChange={v => setFieldValue(`settings.${section}.backgroundColor`, v)} />
                    </div>
                )}
                {!isDatetime && (
                    <div className="preset-settings-panel__field">
                        <label className="field-label text-small-bold"><Translation id="social_media_font_family" /></label>
                        <select className="select-box"
                            value={settings.font || 'inherit'}
                            onChange={e => setFieldValue(`settings.${section}.font`, e.target.value)}>
                            <option value="inherit">System</option>
                            <option value="robotomedium">Roboto</option>
                            <option value="affogatomedium">Affogato</option>
                            <option value="carbonregular">Carbon</option>
                            <option value="circularmedium">Circular</option>
                            <option value="hindregular">Hind</option>
                            <option value="jostregular">Jost</option>
                            <option value="poppinsregular">Poppins</option>
                            <option value="avenirmedium">Avenir</option>
                        </select>
                    </div>
                )}
                <div className="preset-settings-panel__field">
                    <label className="field-label text-small-bold"><Translation id="social_media_font_size" /></label>
                    <input type="number" className="input-text-box input-text-box--short"
                        value={settings.size}
                        onChange={e => setFieldValue(`settings.${section}.size`, parseInt(e.target.value, 10))} />
                </div>
                <div className="preset-settings-panel__field">
                    <label className="field-label text-small-bold"><Translation id="social_media_alignment" /></label>
                    <div className="radio-group">
                        {['left', 'center', 'right'].map(align => (
                            <label key={align} className="radio-label text-small-bold">
                                <input type="radio" name={`${section}-align`} value={align}
                                    checked={settings.align === align}
                                    onChange={() => setFieldValue(`settings.${section}.align`, align)} />
                                {align}
                            </label>
                        ))}
                    </div>
                </div>
                <PositionGrid
                    value={positionValue}
                    onChange={v => setFieldValue(positionField, v)}
                />
            </div>
        )
    }

    render() {
        const { activeSection, showDiscardConfirm, previewFormatId } = this.state
        const { values, handleSubmit, presetId, themeData } = this.props
        const isNew        = !presetId
        const activeFormat = SOCIAL_MEDIA_FORMATS.find(f => f.id === previewFormatId) || SOCIAL_MEDIA_FORMATS[0]

        return (
            <WrapperPageWithSecondNav
                pageTitle={values.name}
                pageTitleTransId={isNew ? 'social_media_new_preset' : 'social_media_edit_preset'}
                navChildren={
                    <PresetSectionNav
                        activeSection={activeSection}
                        onSectionChange={s => this.handleSectionChange(s)}
                    />
                }
            >
                <div className="page-social-media-preset site-content">
                    <div className="preset-editor">

                        <div className="preset-editor__settings">
                            {this.renderSection()}
                        </div>

                        <div className="preset-editor__preview">
                            <div className="preset-format-switcher">
                                {SOCIAL_MEDIA_FORMATS.map(f => (
                                    <button
                                        key={f.id}
                                        className={`preset-format-switcher__btn text-small-bold${previewFormatId === f.id ? ' preset-format-switcher__btn--active' : ''}`}
                                        title={f.label}
                                        onClick={() => this.setState({ previewFormatId: f.id })}>
                                        {f.label}
                                    </button>
                                ))}
                            </div>
                            <PresetPreview settings={values.settings} format={activeFormat} themeData={themeData} />
                        </div>
                    </div>

                    <ButtonSubmitCancel
                        onSubmit={handleSubmit}
                        onCancel={() => this.handleBack()}
                        transIdSubmit="save_button"
                        transIdCancel="cancel_button"
                        cap={EDIT_SOCIAL_MEDIA_CAP}
                    />

                    {showDiscardConfirm && (
                        <div className="preview-movie-dialog-overlay" onClick={() => this.setState({ showDiscardConfirm: false })}>
                            <div className="preview-movie-dialog" onClick={e => e.stopPropagation()}>
                                <div className="preview-movie-dialog-head">
                                    <span className="preview-movie-dialog-title"><Translation id="discard_changes_title" /></span>
                                    <button className="preview-movie-dialog-close text-small-regular" type="button" onClick={() => this.setState({ showDiscardConfirm: false })}>✕</button>
                                </div>
                                <div className="preview-movie-dialog-footer">
                                    <button className="button" onClick={() => this.confirmDiscard()}>
                                        <Translation id="confirm_button" />
                                    </button>
                                    <button className="button button--cancel" type="button" onClick={() => this.setState({ showDiscardConfirm: false })}>
                                        <Translation id="cancel_button" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </WrapperPageWithSecondNav>
        )
    }
}

export default withFormik({
    mapPropsToValues: ({ preset }) => buildInitialValues(preset),
    handleSubmit: (values, { props }) => {
        const payload = { name: values.name, settings: values.settings }
        if (props.presetId) payload.id = props.presetId
        props.onSave(payload, props.presetId)
        props.onBack()
    },
    enableReinitialize: true,
})(PageSocialMediaPreset)
